// ===== SITE TAKEOFF CONSTANTS =====

// Feature flag — set to false to disable expanded area types
export const ENABLE_EXPANDED_AREA_TYPES = true;

// ===== AREA TYPES =====

export const AREA_TYPES = {
  // Hardscape
  HS_SIDEWALK: 'hs_sidewalk',
  HS_PLAZA: 'hs_plaza',
  HS_DUMPSTER_PAD: 'hs_dumpster_pad',
  PV_WALKWAYS: 'pv_walkways',
  AS_PARKING: 'as_parking',
  BUILDING: 'building',
  // Gravel / Desert
  GR_CLEAN: 'gr_clean',
  GR_DESERT_LOW: 'gr_desert_low',
  GR_DESERT_MED: 'gr_desert_med',
  GR_DESERT_HIGH: 'gr_desert_high',
  GR_RIPRAP: 'gr_riprap',
  // Beds / Planters
  BD_SHRUB_LOW: 'bd_shrub_low',
  BD_SHRUB_MED: 'bd_shrub_med',
  BD_SHRUB_HIGH: 'bd_shrub_high',
  BD_FLOWER_COLOR: 'bd_flower_color',
  // Turf
  NT_TURF_OPEN: 'nt_turf_open',
  NT_TURF_OBSTRUCTED: 'nt_turf_obstructed',
  ST_SYNTHETIC: 'st_synthetic',
  // Other Landscape
  GC_GROUNDCOVER: 'gc_groundcover',
  DR_RETENTION: 'dr_retention',
  DR_BAREGROUND: 'dr_bareground',
  // Exclusions
  DO_NOT_SPRAY: 'do_not_spray',
  DO_NOT_SERVICE: 'do_not_service',
  // Trails
  TR_NATURAL: 'tr_natural',
  TR_DG: 'tr_dg',
  // Tree Disposition
  TREE_SALVAGE: 'tree_salvage',
  TREE_REMAIN: 'tree_remain',
  TREE_REMOVE: 'tree_remove',
  // Generic Markers
  POINT_MARKER: 'point_marker',
  ELLIPSE_ZONE: 'ellipse_zone',
};

// ===== LABELS =====

export const AREA_TYPE_LABELS = {
  [AREA_TYPES.HS_SIDEWALK]: 'Sidewalk / Pedestrian Paths',
  [AREA_TYPES.HS_PLAZA]: 'Plaza / Courtyard / Breezeway',
  [AREA_TYPES.HS_DUMPSTER_PAD]: 'Dumpster Pad / Enclosure',
  [AREA_TYPES.PV_WALKWAYS]: 'Paver Walkways / Plazas',
  [AREA_TYPES.AS_PARKING]: 'Parking / Drive Lanes',
  [AREA_TYPES.BUILDING]: 'Building Footprint',
  [AREA_TYPES.GR_CLEAN]: 'Gravel / DG — Open',
  [AREA_TYPES.GR_DESERT_LOW]: 'Desert Planting — Low',
  [AREA_TYPES.GR_DESERT_MED]: 'Desert Planting — Med',
  [AREA_TYPES.GR_DESERT_HIGH]: 'Desert Planting — High',
  [AREA_TYPES.GR_RIPRAP]: 'Rip-Rap / Cobble / Boulder',
  [AREA_TYPES.BD_SHRUB_LOW]: 'Shrub Bed — Low',
  [AREA_TYPES.BD_SHRUB_MED]: 'Shrub Bed — Med',
  [AREA_TYPES.BD_SHRUB_HIGH]: 'Shrub Bed — High',
  [AREA_TYPES.BD_FLOWER_COLOR]: 'Seasonal Color / Annuals',
  [AREA_TYPES.NT_TURF_OPEN]: 'Natural Turf — Open',
  [AREA_TYPES.NT_TURF_OBSTRUCTED]: 'Natural Turf — Obstructed',
  [AREA_TYPES.ST_SYNTHETIC]: 'Synthetic Turf',
  [AREA_TYPES.GC_GROUNDCOVER]: 'Living Groundcover',
  [AREA_TYPES.DR_RETENTION]: 'Retention Basin',
  [AREA_TYPES.DR_BAREGROUND]: 'Bare Ground',  
  [AREA_TYPES.DO_NOT_SPRAY]: 'DO NOT SPRAY',
  [AREA_TYPES.DO_NOT_SERVICE]: 'DO NOT SERVICE',
  [AREA_TYPES.TR_NATURAL]: 'Natural Trail',
  [AREA_TYPES.TR_DG]: 'DG Trail',
  // Tree Disposition
  [AREA_TYPES.TREE_SALVAGE]: 'Tree — Salvage',
  [AREA_TYPES.TREE_REMAIN]: 'Tree — Remain in Place',
  [AREA_TYPES.TREE_REMOVE]: 'Tree — Remove',
  // Generic Markers
  [AREA_TYPES.POINT_MARKER]: 'Point Marker',
  [AREA_TYPES.ELLIPSE_ZONE]: 'Ellipse Zone',
};

// ===== COLORS =====

export const AREA_TYPE_COLORS = {
  // Hardscape — grays
  [AREA_TYPES.HS_SIDEWALK]: '#C0C0C0',
  [AREA_TYPES.HS_PLAZA]: '#A9A9A9',
  [AREA_TYPES.HS_DUMPSTER_PAD]: '#778899',
  [AREA_TYPES.PV_WALKWAYS]: '#D2691E',
  [AREA_TYPES.AS_PARKING]: '#808080',
  [AREA_TYPES.BUILDING]: '#696969',
  // Gravel / Desert — tans
  [AREA_TYPES.GR_CLEAN]: '#DEB887',
  [AREA_TYPES.GR_DESERT_LOW]: '#F4A460',
  [AREA_TYPES.GR_DESERT_MED]: '#DAA520',
  [AREA_TYPES.GR_DESERT_HIGH]: '#B8860B',
  [AREA_TYPES.GR_RIPRAP]: '#8B7355',
  // Beds / Planters — greens/yellows
  [AREA_TYPES.BD_SHRUB_LOW]: '#9ACD32',
  [AREA_TYPES.BD_SHRUB_MED]: '#6B8E23',
  [AREA_TYPES.BD_SHRUB_HIGH]: '#556B2F',
  [AREA_TYPES.BD_FLOWER_COLOR]: '#FF69B4',
  // Turf — greens
  [AREA_TYPES.NT_TURF_OPEN]: '#228B22',
  [AREA_TYPES.NT_TURF_OBSTRUCTED]: '#2E8B57',
  [AREA_TYPES.ST_SYNTHETIC]: '#00FA9A',
  // Other landscape
  [AREA_TYPES.GC_GROUNDCOVER]: '#32CD32',
  [AREA_TYPES.DR_RETENTION]: '#4169E1',
  [AREA_TYPES.DR_BAREGROUND]: '#a12a21',
  
  // Exclusions
  [AREA_TYPES.DO_NOT_SPRAY]: '#FF0000',
  [AREA_TYPES.DO_NOT_SERVICE]: '#800080',
  // Trails
  [AREA_TYPES.TR_NATURAL]: '#8B4513',
  [AREA_TYPES.TR_DG]: '#D2B48C',
  // Tree Disposition
  [AREA_TYPES.TREE_SALVAGE]: '#1E90FF',    // blue — relocate/save
  [AREA_TYPES.TREE_REMAIN]: '#228B22',     // green — stays
  [AREA_TYPES.TREE_REMOVE]: '#DC143C',     // red — remove
  // Generic Markers
  [AREA_TYPES.POINT_MARKER]: '#FF8C00',    // orange
  [AREA_TYPES.ELLIPSE_ZONE]: '#9370DB',    // purple
};

// ===== PLANT-BEARING TYPES (show density controls) =====

export const PLANT_BEARING_TYPES = [
  AREA_TYPES.GR_DESERT_LOW,
  AREA_TYPES.GR_DESERT_MED,
  AREA_TYPES.GR_DESERT_HIGH,
  AREA_TYPES.BD_SHRUB_LOW,
  AREA_TYPES.BD_SHRUB_MED,
  AREA_TYPES.BD_SHRUB_HIGH,
  AREA_TYPES.BD_FLOWER_COLOR,
  AREA_TYPES.GC_GROUNDCOVER,
];

// ===== DENSITY OPTIONS =====

export const SHRUB_DENSITY_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'low', label: 'Low (< 30% cover)' },
  { value: 'med', label: 'Med (30-60% cover)' },
  { value: 'high', label: 'High (> 60% cover)' },
];

// ===== MODIFIER OPTIONS =====

export const MODIFIER_DEFS = {
  access: {
    label: 'Access',
    type: 'toggle',
    options: ['open', 'obstructed'],
    default: 'open',
  },
  slope: {
    label: 'Slope',
    type: 'toggle',
    options: ['flat', 'sloped'],
    default: 'flat',
  },
  litterExposure: {
    label: 'Litter Exposure',
    type: 'toggle',
    options: ['low', 'high'],
    default: 'low',
  },
  weedPressure: {
    label: 'Weed Pressure',
    type: 'select',
    options: ['low', 'med', 'high'],
    default: 'low',
  },
  limitedAccess: {
    label: 'Limited Access',
    type: 'checkbox',
    default: false,
  },
  blowRestrictions: {
    label: 'Blow Restrictions',
    type: 'checkbox',
    default: false,
  },
  irrigationIncluded: {
    label: 'Irrigation',
    type: 'select',
    options: ['none', 'basic', 'full'],
    default: 'none',
  },
};

// Default modifier values
export const DEFAULT_MODIFIERS = {
  access: 'open',
  slope: 'flat',
  litterExposure: 'low',
  weedPressure: 'low',
  limitedAccess: false,
  blowRestrictions: false,
  irrigationIncluded: 'none',
};

// Default plant density values
export const DEFAULT_PLANT_DENSITY = {
  treeCount: 0,
  shrubDensity: 'none',
  groundcoverDensity: 'none',
};

// ===== CATEGORY GROUPINGS (for summary view) =====

export const AREA_CATEGORIES = {
  HARDSCAPE: {
    label: 'Hardscape / Structures',
    types: [
      AREA_TYPES.HS_SIDEWALK,
      AREA_TYPES.HS_PLAZA,
      AREA_TYPES.HS_DUMPSTER_PAD,
      AREA_TYPES.PV_WALKWAYS,
      AREA_TYPES.AS_PARKING,
      AREA_TYPES.BUILDING,
      AREA_TYPES.TR_DG,
    ],
  },
  GRAVEL_DESERT: {
    label: 'Gravel / Desert',
    types: [
      AREA_TYPES.GR_CLEAN,
      AREA_TYPES.GR_DESERT_LOW,
      AREA_TYPES.GR_DESERT_MED,
      AREA_TYPES.GR_DESERT_HIGH,
      AREA_TYPES.GR_RIPRAP,
    ],
  },
  BEDS_PLANTERS: {
    label: 'Beds / Planters',
    types: [
      AREA_TYPES.BD_SHRUB_LOW,
      AREA_TYPES.BD_SHRUB_MED,
      AREA_TYPES.BD_SHRUB_HIGH,
      AREA_TYPES.BD_FLOWER_COLOR,
    ],
  },
  TURF: {
    label: 'Turf',
    types: [
      AREA_TYPES.NT_TURF_OPEN,
      AREA_TYPES.NT_TURF_OBSTRUCTED,
      AREA_TYPES.ST_SYNTHETIC,
    ],
  },
  OTHER_LANDSCAPE: {
    label: 'Other Landscape',
    types: [
      AREA_TYPES.GC_GROUNDCOVER,
      AREA_TYPES.DR_RETENTION,
      AREA_TYPES.TR_NATURAL,
      AREA_TYPES.DR_BAREGROUND
    ],
  },
  EXCLUSIONS: {
    label: 'Exclusion Zones',
    types: [
      AREA_TYPES.DO_NOT_SPRAY,
      AREA_TYPES.DO_NOT_SERVICE,
    ],
  },
  TREE_DISPOSITION: {
    label: 'Tree Disposition',
    types: [
      AREA_TYPES.TREE_SALVAGE,
      AREA_TYPES.TREE_REMAIN,
      AREA_TYPES.TREE_REMOVE,
    ],
  },
  MARKERS: {
    label: 'Markers / Zones',
    types: [
      AREA_TYPES.POINT_MARKER,
      AREA_TYPES.ELLIPSE_ZONE,
    ],
  },
};

// Landscape categories (for total landscape SF)
export const LANDSCAPE_CATEGORIES = ['GRAVEL_DESERT', 'BEDS_PLANTERS', 'TURF', 'OTHER_LANDSCAPE'];
export const HARDSCAPE_CATEGORIES = ['HARDSCAPE'];

// ===== SERVICES =====

export const SERVICES = {
  MOWING: 'mowing',
  EDGING: 'edging',
  BLOWING: 'blowing',
  TRIMMING: 'trimming',
  PRUNING: 'pruning',
  WEED_CONTROL: 'weed_control',
  PRE_EMERGENT: 'pre_emergent',
  FERTILIZATION: 'fertilization',
  DEBRIS_REMOVAL: 'debris_removal',
  SWEEPING: 'sweeping',
  TREE_TRIMMING: 'tree_trimming',
  PALM_TRIMMING: 'palm_trimming',
  IRRIGATION_CHECK: 'irrigation_check',
  PLANTING: 'planting',
  DEADHEADING: 'deadheading',
  PEST_CONTROL: 'pest_control',
  LITTER_PICKUP: 'litter_pickup',
};

export const SERVICE_LABELS = {
  [SERVICES.MOWING]: 'Mowing',
  [SERVICES.EDGING]: 'Edging',
  [SERVICES.BLOWING]: 'Blowing',
  [SERVICES.TRIMMING]: 'Trimming / Hedging',
  [SERVICES.PRUNING]: 'Low Pruning (< 8\')',
  [SERVICES.WEED_CONTROL]: 'Weed Control',
  [SERVICES.PRE_EMERGENT]: 'Pre-Emergent',
  [SERVICES.FERTILIZATION]: 'Fertilization',
  [SERVICES.DEBRIS_REMOVAL]: 'Debris Removal',
  [SERVICES.SWEEPING]: 'Sweeping',
  [SERVICES.TREE_TRIMMING]: 'Tree Trimming',
  [SERVICES.PALM_TRIMMING]: 'Palm Trimming',
  [SERVICES.IRRIGATION_CHECK]: 'Irrigation Check',
  [SERVICES.PLANTING]: 'Planting / Rotation',
  [SERVICES.DEADHEADING]: 'Deadheading',
  [SERVICES.PEST_CONTROL]: 'Pest Control',
  [SERVICES.LITTER_PICKUP]: 'Litter Pickup',
};

// ===== SPRAY / HERBICIDE CLASSIFICATION =====
// Simplified categories used for pre-emergent and herbicide planning.
// Each takeoff area type maps to exactly one spray type. Users can still
// override per-area by toggling the pre_emergent service on/off.

export const SPRAY_TYPES = {
  TURF: 'turf',
  ORNAMENTAL: 'ornamental',
  BARE_GROUND: 'bare_ground',
  NONE: 'none',
};

export const SPRAY_TYPE_LABELS = {
  [SPRAY_TYPES.TURF]: 'Turf',
  [SPRAY_TYPES.ORNAMENTAL]: 'Ornamental',
  [SPRAY_TYPES.BARE_GROUND]: 'Bare Ground',
  [SPRAY_TYPES.NONE]: 'No Spray',
};

export const SPRAY_TYPE_COLORS = {
  [SPRAY_TYPES.TURF]: '#00FF00',       // Green
  [SPRAY_TYPES.ORNAMENTAL]: '#FFFF00', // Yellow
  [SPRAY_TYPES.BARE_GROUND]: '#FFA500', // Orange
  [SPRAY_TYPES.NONE]: '#9e9e9e',       // Gray
};

// Takeoff area type -> spray type mapping
export const SPRAY_TYPE_BY_AREA = {
  // Turf
  [AREA_TYPES.NT_TURF_OPEN]: SPRAY_TYPES.TURF,
  [AREA_TYPES.NT_TURF_OBSTRUCTED]: SPRAY_TYPES.TURF,
  [AREA_TYPES.ST_SYNTHETIC]: SPRAY_TYPES.NONE,
  // Gravel / Desert
  [AREA_TYPES.GR_CLEAN]: SPRAY_TYPES.BARE_GROUND,
  [AREA_TYPES.GR_DESERT_LOW]: SPRAY_TYPES.ORNAMENTAL,
  [AREA_TYPES.GR_DESERT_MED]: SPRAY_TYPES.ORNAMENTAL,
  [AREA_TYPES.GR_DESERT_HIGH]: SPRAY_TYPES.ORNAMENTAL,
  [AREA_TYPES.GR_RIPRAP]: SPRAY_TYPES.BARE_GROUND,
  // Beds / Planters
  [AREA_TYPES.BD_SHRUB_LOW]: SPRAY_TYPES.ORNAMENTAL,
  [AREA_TYPES.BD_SHRUB_MED]: SPRAY_TYPES.ORNAMENTAL,
  [AREA_TYPES.BD_SHRUB_HIGH]: SPRAY_TYPES.ORNAMENTAL,
  [AREA_TYPES.BD_FLOWER_COLOR]: SPRAY_TYPES.ORNAMENTAL,
  // Other Landscape
  [AREA_TYPES.GC_GROUNDCOVER]: SPRAY_TYPES.ORNAMENTAL,
  [AREA_TYPES.DR_RETENTION]: SPRAY_TYPES.ORNAMENTAL,
  [AREA_TYPES.DR_BAREGROUND]: SPRAY_TYPES.BARE_GROUND,
  // Trails
  [AREA_TYPES.TR_NATURAL]: SPRAY_TYPES.BARE_GROUND,
  [AREA_TYPES.TR_DG]: SPRAY_TYPES.BARE_GROUND,
  // Hardscape
  [AREA_TYPES.HS_SIDEWALK]: SPRAY_TYPES.NONE,
  [AREA_TYPES.HS_PLAZA]: SPRAY_TYPES.NONE,
  [AREA_TYPES.HS_DUMPSTER_PAD]: SPRAY_TYPES.NONE,
  [AREA_TYPES.PV_WALKWAYS]: SPRAY_TYPES.NONE,
  [AREA_TYPES.AS_PARKING]: SPRAY_TYPES.NONE,
  [AREA_TYPES.BUILDING]: SPRAY_TYPES.NONE,
  // Tree Disposition (point markers)
  [AREA_TYPES.TREE_SALVAGE]: SPRAY_TYPES.NONE,
  [AREA_TYPES.TREE_REMAIN]: SPRAY_TYPES.NONE,
  [AREA_TYPES.TREE_REMOVE]: SPRAY_TYPES.NONE,
  // Exclusions
  [AREA_TYPES.DO_NOT_SPRAY]: SPRAY_TYPES.NONE,
  [AREA_TYPES.DO_NOT_SERVICE]: SPRAY_TYPES.NONE,
  // Generic Markers
  [AREA_TYPES.POINT_MARKER]: SPRAY_TYPES.NONE,
  [AREA_TYPES.ELLIPSE_ZONE]: SPRAY_TYPES.NONE,
};

// Get default spray type for an area type
export const getSprayTypeForArea = (areaType) => {
  const resolved = resolveAreaType(areaType);
  return SPRAY_TYPE_BY_AREA[resolved] || SPRAY_TYPES.NONE;
};

// Area types that are sprayable by default (used for service auto-suggestion)
export const isSprayableType = (areaType) => {
  const spray = getSprayTypeForArea(areaType);
  return spray !== SPRAY_TYPES.NONE;
};

// Auto-suggested services per area type — user can override.
// NOTE: pre_emergent is automatically included for any area type whose
// SPRAY_TYPE_BY_AREA maps to turf, ornamental, or bare_ground — see
// getSuggestedServices() below which unions the base list with pre_emergent.
// Conservative default services per area type — based on Phoenix AZ
// commercial/government maintenance spec. Hardscape gets cleanup + crack
// weed control only. Landscape gets density-appropriate pruning + weed/
// pre-emergent. Tree/palm trimming, irrigation check, and pest control
// are asset-driven or site-level — not auto-assigned to area polygons.
export const DEFAULT_SERVICES_BY_TYPE = {
  // Turf
  [AREA_TYPES.NT_TURF_OPEN]: [SERVICES.MOWING, SERVICES.EDGING, SERVICES.BLOWING, SERVICES.FERTILIZATION, SERVICES.WEED_CONTROL, SERVICES.LITTER_PICKUP],
  [AREA_TYPES.NT_TURF_OBSTRUCTED]: [SERVICES.MOWING, SERVICES.EDGING, SERVICES.BLOWING, SERVICES.TRIMMING, SERVICES.FERTILIZATION, SERVICES.WEED_CONTROL, SERVICES.LITTER_PICKUP],
  [AREA_TYPES.ST_SYNTHETIC]: [SERVICES.BLOWING, SERVICES.LITTER_PICKUP, SERVICES.DEBRIS_REMOVAL],
  // Gravel / Desert surface
  [AREA_TYPES.GR_CLEAN]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.LITTER_PICKUP],
  [AREA_TYPES.GR_DESERT_LOW]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.LITTER_PICKUP, SERVICES.PRUNING],
  [AREA_TYPES.GR_DESERT_MED]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.LITTER_PICKUP, SERVICES.DEBRIS_REMOVAL, SERVICES.PRUNING],
  [AREA_TYPES.GR_DESERT_HIGH]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.LITTER_PICKUP, SERVICES.DEBRIS_REMOVAL, SERVICES.PRUNING, SERVICES.TRIMMING],
  [AREA_TYPES.GR_RIPRAP]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.LITTER_PICKUP, SERVICES.DEBRIS_REMOVAL],
  // Beds / Planters
  [AREA_TYPES.BD_SHRUB_LOW]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.LITTER_PICKUP, SERVICES.PRUNING],
  [AREA_TYPES.BD_SHRUB_MED]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.LITTER_PICKUP, SERVICES.DEBRIS_REMOVAL, SERVICES.PRUNING, SERVICES.TRIMMING],
  [AREA_TYPES.BD_SHRUB_HIGH]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.LITTER_PICKUP, SERVICES.DEBRIS_REMOVAL, SERVICES.PRUNING, SERVICES.TRIMMING, SERVICES.FERTILIZATION],
  [AREA_TYPES.BD_FLOWER_COLOR]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.LITTER_PICKUP, SERVICES.DEADHEADING, SERVICES.FERTILIZATION, SERVICES.PLANTING],
  // Other Landscape
  [AREA_TYPES.GC_GROUNDCOVER]: [SERVICES.TRIMMING, SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.BLOWING, SERVICES.LITTER_PICKUP],
  [AREA_TYPES.DR_RETENTION]: [SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.BLOWING, SERVICES.LITTER_PICKUP, SERVICES.DEBRIS_REMOVAL],
  [AREA_TYPES.DR_BAREGROUND]: [SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.BLOWING, SERVICES.LITTER_PICKUP, SERVICES.DEBRIS_REMOVAL],
  // Hardscape — cleanup + crack/edge weed control only
  [AREA_TYPES.HS_SIDEWALK]: [SERVICES.BLOWING, SERVICES.SWEEPING, SERVICES.LITTER_PICKUP, SERVICES.WEED_CONTROL],
  [AREA_TYPES.HS_PLAZA]: [SERVICES.BLOWING, SERVICES.SWEEPING, SERVICES.LITTER_PICKUP, SERVICES.WEED_CONTROL],
  [AREA_TYPES.HS_DUMPSTER_PAD]: [SERVICES.BLOWING, SERVICES.LITTER_PICKUP, SERVICES.DEBRIS_REMOVAL, SERVICES.WEED_CONTROL],
  [AREA_TYPES.PV_WALKWAYS]: [SERVICES.BLOWING, SERVICES.SWEEPING, SERVICES.LITTER_PICKUP, SERVICES.WEED_CONTROL],
  [AREA_TYPES.AS_PARKING]: [SERVICES.BLOWING, SERVICES.SWEEPING, SERVICES.LITTER_PICKUP, SERVICES.WEED_CONTROL],
  [AREA_TYPES.BUILDING]: [],
  // Exclusions
  [AREA_TYPES.DO_NOT_SPRAY]: [],
  [AREA_TYPES.DO_NOT_SERVICE]: [],
  // Trails
  [AREA_TYPES.TR_NATURAL]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.LITTER_PICKUP, SERVICES.DEBRIS_REMOVAL],
  [AREA_TYPES.TR_DG]: [SERVICES.BLOWING, SERVICES.WEED_CONTROL, SERVICES.PRE_EMERGENT, SERVICES.LITTER_PICKUP, SERVICES.EDGING, SERVICES.DEBRIS_REMOVAL],
  // Tree Disposition — asset-driven, minimal area defaults
  [AREA_TYPES.TREE_SALVAGE]: [SERVICES.TREE_TRIMMING],
  [AREA_TYPES.TREE_REMAIN]: [SERVICES.TREE_TRIMMING, SERVICES.PRUNING],
  [AREA_TYPES.TREE_REMOVE]: [],
  // Generic Markers
  [AREA_TYPES.POINT_MARKER]: [],
  [AREA_TYPES.ELLIPSE_ZONE]: [],
};

// Get suggested services for an area type
export const getSuggestedServices = (areaType) => {
  const resolved = resolveAreaType(areaType);
  return DEFAULT_SERVICES_BY_TYPE[resolved] || [];
};

// ===== LEGACY TYPE MAPPING =====
// Maps old area types to new equivalents for display
export const LEGACY_TYPE_MAP = {
  turf: AREA_TYPES.NT_TURF_OPEN,
  ornamental: AREA_TYPES.BD_SHRUB_MED,
  bare_ground: AREA_TYPES.GR_CLEAN,
};

// Resolve an areaType (handles legacy values)
export const resolveAreaType = (areaType) => {
  if (!areaType) return AREA_TYPES.GR_CLEAN;
  if (AREA_TYPE_LABELS[areaType]) return areaType;
  if (LEGACY_TYPE_MAP[areaType]) return LEGACY_TYPE_MAP[areaType];
  return areaType;
};

// ===== PRODUCTION RATES (labor calc defaults) =====

// visitsPerYear: how many times/year this service is performed.
// The calculator divides hours by (visitsPerYear / totalVisitsPerYear) to get per-visit cost.
// Default totalVisitsPerYear = 42 (weekly visits ~10 months in AZ).
export const DEFAULT_VISITS_PER_YEAR = 42;

// Labor categories — different billing rates
export const LABOR_CATEGORIES = {
  mtc:        { label: 'Maintenance (General)', color: '#1565c0' },
  arborist:   { label: 'Arborist', color: '#5d4037' },
  herbicide:  { label: 'Herbicide Tech', color: '#e65100' },
  irrigation: { label: 'Irrigation Tech', color: '#2e7d32' },
};

// Rates are PER MANHOUR — what one person can cover in one hour.
// For desert commercial: crews walk fast, spray weeds, minimal mowing.
export const DEFAULT_PRODUCTION_RATES = {
  // ── Maintenance crew ──
  mowing:          { rate: 40000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Mowing' },
  edging:          { rate: 5000,  unit: 'lf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Edging' },
  blowing:         { rate: 80000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Blowing' },
  weed_control:    { rate: 45000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Weed Control' },
  debris_removal:  { rate: 65000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Debris Removal' },
  litter_pickup:   { rate: 65000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Litter Pickup' },
  sweeping:        { rate: 60000, unit: 'sf_hr',    visitsPerYear: 42, coveragePerVisit: 1.0, category: 'mtc', label: 'Sweeping' },
  trimming:        { rate: 12000, unit: 'sf_hr',    visitsPerYear: 12, coveragePerVisit: 1.0, category: 'mtc', label: 'Trimming / Hedging' },
  pruning:         { rate: 12,    unit: 'trees_or_sf_hr', visitsPerYear: 6, coveragePerVisit: 1.0, category: 'mtc', label: 'Low Pruning (< 8\')', sfRate: 10000 },
  deadheading:     { rate: 8000,  unit: 'sf_hr',    visitsPerYear: 12, coveragePerVisit: 1.0, category: 'mtc', label: 'Deadheading' },
  planting:        { rate: 4000,  unit: 'sf_hr',    visitsPerYear: 3,  coveragePerVisit: 1.0, category: 'mtc', label: 'Planting / Rotation' },

  // ── Arborist ──
  tree_trimming:   { rate: 4,     unit: 'trees_hr', visitsPerYear: 2,  coveragePerVisit: 1.0, category: 'arborist', label: 'Tree Trimming' },
  palm_trimming:   { rate: 3,     unit: 'trees_hr', visitsPerYear: 2,  coveragePerVisit: 1.0, category: 'arborist', label: 'Palm Trimming' },

  // ── Herbicide tech ──
  pre_emergent:    { rate: 65000, unit: 'sf_hr',    visitsPerYear: 2,  coveragePerVisit: 1.0, category: 'herbicide', label: 'Pre-Emergent' },
  fertilization:   { rate: 65000, unit: 'sf_hr',    visitsPerYear: 3,  coveragePerVisit: 1.0, category: 'herbicide', label: 'Fertilization' },
  pest_control:    { rate: 65000, unit: 'sf_hr',    visitsPerYear: 4,  coveragePerVisit: 1.0, category: 'herbicide', label: 'Pest Control' },

  // ── Irrigation tech ──
  irrigation_check:{ rate: 80000, unit: 'sf_hr',    visitsPerYear: 12, coveragePerVisit: 1.0, category: 'irrigation', label: 'Irrigation Check' },
};

export const RATE_UNIT_LABELS = {
  sf_hr: 'SF/hr',
  lf_hr: 'LF/hr',
  trees_hr: 'trees/hr',
  trees_or_sf_hr: 'trees/hr',
};

export const MODIFIER_MULTIPLIERS = {
  access_obstructed: 1.25,
  slope_sloped: 1.15,
  litterExposure_high: 1.2,
  weedPressure_med: 1.15,
  weedPressure_high: 1.35,
  limitedAccess: 1.3,
  blowRestrictions: 1.4,
};

// Default width in feet for polyline-drawn areas
export const DEFAULT_LINE_WIDTH = 4;

// Tree disposition types (show treeDetails editor)
export const TREE_TYPES = [
  AREA_TYPES.TREE_SALVAGE,
  AREA_TYPES.TREE_REMAIN,
  AREA_TYPES.TREE_REMOVE,
];

export const DEFAULT_TREE_DETAILS = {
  species: '',
  height: 0,
  caliper: 0,
  canopySpread: 0,
  condition: '',
};

export const TREE_CONDITION_OPTIONS = [
  { value: '', label: 'Not assessed' },
  { value: 'good', label: 'Good' },
  { value: 'fair', label: 'Fair' },
  { value: 'poor', label: 'Poor' },
  { value: 'dead', label: 'Dead' },
];

// Common AZ tree species for autocomplete suggestions
export const COMMON_TREE_SPECIES = [
  'Palo Brea',
  'Palo Verde - Blue',
  'Palo Verde - Foothills',
  'Palo Verde - Desert Museum',
  'Mesquite - Chilean',
  'Mesquite - Velvet',
  'Mesquite - Argentine',
  'Mesquite - Honey',
  'Ironwood',
  'Acacia - Sweet',
  'Acacia - Whitethorn',
  'Olive - Swan Hill',
  'Olive - Fruitless',
  'Sissoo',
  'Ficus - Indian Laurel',
  'Ficus - Nitida',
  'Pine - Aleppo',
  'Pine - Eldarica',
  'Eucalyptus',
  'Ash - Fan-Tex',
  'Ash - Raywood',
  'Ash - Arizona',
  'Palm - Date',
  'Palm - Fan',
  'Palm - Queen',
  'Palm - King',
  'Palm - Mexican Fan',
  'Vitex',
  'Tipu',
  'Jacaranda',
  'Bottle Tree',
  'Willow - Desert',
  'Willow - Goodding',
  'Citrus',
  'Texas Ebony',
  'Chaste Tree',
];

// ===== PLACEMENT QUEUE ITEM TYPES =====
// Each type defines: label, color, default areaType for placed points, and detail fields with labels
export const PLACEMENT_ITEM_TYPES = {
  tree: {
    label: 'Tree',
    color: '#228B22',
    defaultAreaType: AREA_TYPES.TREE_REMAIN,
    fields: [
      { key: 'species', label: 'Species', type: 'text' },
      { key: 'caliper', label: 'Caliper (in)', type: 'number' },
      { key: 'height', label: 'Height (ft)', type: 'number' },
      { key: 'canopySpread', label: 'Spread (ft)', type: 'number' },
      { key: 'condition', label: 'Condition', type: 'text' },
      { key: 'disposition', label: 'Disposition', type: 'text' },
    ],
    buildLabel: (d) => [d.species || d.commonName, d.caliper ? `${d.caliper}" cal` : '', d.height ? `${d.height}' ht` : ''].filter(Boolean).join(' — ') || 'Tree',
  },
  valve: {
    label: 'Irrigation Valve',
    color: '#2196F3',
    defaultAreaType: AREA_TYPES.POINT_MARKER,
    fields: [
      { key: 'zone', label: 'Zone', type: 'text' },
      { key: 'size', label: 'Size', type: 'text' },
      { key: 'valveType', label: 'Type', type: 'text' },
      { key: 'manufacturer', label: 'Manufacturer', type: 'text' },
      { key: 'gpm', label: 'GPM', type: 'number' },
    ],
    buildLabel: (d) => [d.zone ? `Zone ${d.zone}` : '', d.size, d.valveType].filter(Boolean).join(' — ') || 'Valve',
  },
  controller: {
    label: 'Controller',
    color: '#FF9800',
    defaultAreaType: AREA_TYPES.POINT_MARKER,
    fields: [
      { key: 'manufacturer', label: 'Manufacturer', type: 'text' },
      { key: 'model', label: 'Model', type: 'text' },
      { key: 'zones', label: 'Zones', type: 'number' },
      { key: 'locationDesc', label: 'Location', type: 'text' },
    ],
    buildLabel: (d) => [d.manufacturer, d.model, d.zones ? `${d.zones} zones` : ''].filter(Boolean).join(' — ') || 'Controller',
  },
  backflow: {
    label: 'Backflow',
    color: '#9C27B0',
    defaultAreaType: AREA_TYPES.POINT_MARKER,
    fields: [
      { key: 'backflowType', label: 'Type', type: 'text' },
      { key: 'size', label: 'Size', type: 'text' },
      { key: 'serial', label: 'Serial #', type: 'text' },
      { key: 'testDue', label: 'Test Due', type: 'text' },
    ],
    buildLabel: (d) => [d.backflowType, d.size, d.serial].filter(Boolean).join(' — ') || 'Backflow',
  },
  plant: {
    label: 'Plant Material',
    color: '#4CAF50',
    defaultAreaType: AREA_TYPES.POINT_MARKER,
    fields: [
      { key: 'species', label: 'Species', type: 'text' },
      { key: 'size', label: 'Size', type: 'text' },
      { key: 'qty', label: 'Qty', type: 'number' },
      { key: 'spacing', label: 'Spacing', type: 'text' },
      { key: 'container', label: 'Container', type: 'text' },
    ],
    buildLabel: (d) => [d.species, d.size, d.qty ? `x${d.qty}` : ''].filter(Boolean).join(' — ') || 'Plant',
  },
  boulder: {
    label: 'Boulder / Rock',
    color: '#8B7355',
    defaultAreaType: AREA_TYPES.POINT_MARKER,
    fields: [
      { key: 'material', label: 'Material', type: 'text' },
      { key: 'size', label: 'Size', type: 'text' },
      { key: 'qty', label: 'Qty', type: 'number' },
      { key: 'color', label: 'Color', type: 'text' },
      { key: 'notes', label: 'Notes', type: 'text' },
    ],
    buildLabel: (d) => [d.material, d.size, d.qty ? `x${d.qty}` : ''].filter(Boolean).join(' — ') || 'Boulder',
  },
};

// ===== EXCLUSION ZONE TYPES =====

export const EXCLUSION_TYPES = {
  BUILDING: 'building',
  POOL: 'pool',
  PARKING_ISLAND: 'parking_island',
  PLAYGROUND: 'playground',
  DUMPSTER_PAD: 'dumpster_pad',
  OTHER: 'other',
};

export const EXCLUSION_TYPE_LABELS = {
  [EXCLUSION_TYPES.BUILDING]: 'Building',
  [EXCLUSION_TYPES.POOL]: 'Pool',
  [EXCLUSION_TYPES.PARKING_ISLAND]: 'Parking Island',
  [EXCLUSION_TYPES.PLAYGROUND]: 'Playground',
  [EXCLUSION_TYPES.DUMPSTER_PAD]: 'Dumpster Pad',
  [EXCLUSION_TYPES.OTHER]: 'Other',
};

export const EXCLUSION_TYPE_COLORS = {
  [EXCLUSION_TYPES.BUILDING]: '#696969',
  [EXCLUSION_TYPES.POOL]: '#4FC3F7',
  [EXCLUSION_TYPES.PARKING_ISLAND]: '#9E9E9E',
  [EXCLUSION_TYPES.PLAYGROUND]: '#FF7043',
  [EXCLUSION_TYPES.DUMPSTER_PAD]: '#78909C',
  [EXCLUSION_TYPES.OTHER]: '#BDBDBD',
};

export const isExclusionArea = (area) => !!area?.parentAreaId;

// Get label for any areaType (handles legacy)
export const getAreaTypeLabel = (areaType) => {
  const resolved = resolveAreaType(areaType);
  return AREA_TYPE_LABELS[resolved] || areaType || 'Unknown';
};

// Get color for any areaType (handles legacy)
export const getAreaTypeColor = (areaType) => {
  const resolved = resolveAreaType(areaType);
  return AREA_TYPE_COLORS[resolved] || '#3388ff';
};
